import keyMirror from 'keymirror';

export const InfoModalActionTypes = keyMirror({
  OPEN_INFO_MODAL: undefined,
  HIDE_INFO_MODAL: undefined,
});
